<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-share-alt"></i>
        {{ $t('CHANNEL_SETTINGS_SHARED_TITLE') }}:
      </h5>
    </div>

    <div class="card-body">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="shared_checkbox" name="customCheckbox" class="custom-control-input"
               v-model="settings.isShared">
        <label class="custom-control-label" for="shared_checkbox">{{ $t('CHANNEL_SETTINGS_SHARED_CHECKBOX_LABEL') }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SharedChannelSettings',
  computed: {
    settings() {
      return this.$store.getters.getChannelSettings;
    },
  },
};
</script>

<style scoped>

</style>
